// Helpers for the /payslip_settings contract:
// GET  -> { country, paye: { isView, name }, settings: [{ taxName, isView, name }] }
// POST -> { paye: { name }, settings: [{ taxName, isView, name }] }
// `settings` is country-driven (configured by SuperAdmin), so never assume
// which tax rules exist or what they are labelled.

// Older responses were an array wrapping the object; accept both.
const unwrap = (payslipSettings) =>
  Array.isArray(payslipSettings) ? payslipSettings[0] : payslipSettings;

export const getTaxSetting = (payslipSettings, taxName) =>
  (unwrap(payslipSettings)?.settings || []).find(
    (item) => item?.taxName === taxName
  );

// Visible-on-payslip entry for a tax rule, or undefined when the rule does
// not exist for this company's country or the admin has hidden it.
export const getVisibleTaxSetting = (payslipSettings, taxName) => {
  const setting = getTaxSetting(payslipSettings, taxName);
  return setting?.isView === true ? setting : undefined;
};

// Display label comes from the backend: the admin-set name, else the rule's taxName.
export const getTaxLabel = (setting) => setting?.name || setting?.taxName || "";

export const buildPayslipSettingPayload = (settings, payeName, data) => {
  const current = unwrap(data);
  return {
    paye: {
      name: payeName || current?.paye?.name,
    },
    settings: (settings || [])
      .filter((item) => item?.taxName)
      .map((item) => ({
        taxName: item.taxName,
        isView: item?.isView || false,
        name: item?.name || getTaxSetting(current, item.taxName)?.name,
      })),
  };
};
